import React from 'react'

import LotsContainer from '../components/lots/LotsContainer'

const LotsScreen = props => <LotsContainer {...props} />

export default LotsScreen
